module.exports = __webpack_public_path__ + "img/img11.d7d40380.jpg";